import { backend } from 'api/clients';

export const getReport = id => backend.get(`/api/v1/idm-reports/${id}`);
